<script setup>
import { useSpeechRate } from '@/composables/useSpeechRate.js';
import { Tippy } from 'vue-tippy';
import { IconInfoCircle } from '@tabler/icons-vue';

const { rate } = useSpeechRate();
</script>

<template>
    <div class="flex gap-x-1">
        <Tippy>
            <button>
                <IconInfoCircle class="w-6 h-6 text-gray-400" />
            </button>
            <template #content>
                {{ $t('messages.speech_rate') }}
            </template>
        </Tippy>
        <input type="range" name="speech_rate" id="speech_rate" v-model="rate" min="0.5" max="2" step="0.1" />
    </div>
</template>
